import request from '@/utils/request1';

export const COMMON_PREFIX = '/api';

export const STATIC_URL = {
  ENUM: `${COMMON_PREFIX}/gmrfid-service-community/admin/manager/enums`,
  ASYNC_IMPORT: `${COMMON_PREFIX}/gmrfid-service-common/asyncTask?taskType`,
  SUPERVISION_ROLE: `${COMMON_PREFIX}/gmrfid-service-user/admin/role/supervision_role/list`,
};

export const EnumType = {
  idCardType: 'idCardType', // 证件类型
  housePurpose: 'housePurpose', // 房屋用途
  companyType: 'companyType', // 企业服务类型
  asyncTaskType: 'asyncTaskType', // 异步任务类型
  asyncTaskStatus: 'asyncTaskStatus', // 异步任务状态
};

export function getEnumType(type) {
  return request(STATIC_URL.ENUM, { method: 'GET', login: true, params: { type } })
    .then((r) => r?.data, (error) => Promise.reject(error));
}

export function getAsyncTask(params) {
  return request(STATIC_URL.ASYNC_IMPORT, { method: 'GET', login: true, params })
    .then((r) => r?.data, (error) => Promise.reject(error));
}

// 系统维护 替换文件
export function uploadFileApi(options: any) {
  return request('/api/gmrfid-service-user/admin/system_maintenance/file/replace', {
    method: 'POST',
    body: options.data,
    // FormData 场景下需要同时把 data 也设成 formData，axios 才会按 multipart 发送
    data: options.data,
    headers: options.headers,
  });
}

// 系统维护 业主小程序菜单查询
export function getOwnerMenuApi(options: any) {
  return request('/api/gmrfid-service-user/admin/system_maintenance/ownerMenu/tree', {
    method: 'GET',
    params: options.params,
    headers: options.headers,
  });
}

// 系统维护 业主小程序菜单删除
export function delOwnerMenuApi(options: any) {
  return request(`/api/gmrfid-service-user/admin/system_maintenance/ownerMenu/${options.data.id}`, {
    method: 'DELETE',
    headers: options.headers,
  });
}

// 系统维护 业主小程序菜单修改
export function editOwnerMenuApi(options: any) {
  return request('/api/gmrfid-service-user/admin/system_maintenance/ownerMenu/update', {
    method: 'POST',
    body: options.data,
    headers: options.headers,
  });
}

// 系统维护 业主小程序菜单新增
export function addOwnerMenuApi(options: any) {
  return request('/api/gmrfid-service-user/admin/system_maintenance/ownerMenu/add', {
    method: 'POST',
    body: options.data,
    headers: options.headers,
  });
}

// 查询监管角色列表
export function getSupervisionRolesApi() {
  return request(STATIC_URL.SUPERVISION_ROLE, { method: 'GET', login: true })
    .then((r) => r?.data, (error) => Promise.reject(error));
}
